// WARNING: Do NOT edit this file outside npm-helsecore, it will be reset on build!

import type { NavigationCardsProps } from "@dip/helsecore/src/components/parts/NavigationCards/NavigationCards.d";
import { NavigationCards } from  "@dip/helsecore/src/components/parts/NavigationCards/NavigationCards"
import React from 'react';

export default function (props: Readonly<NavigationCardsProps>): React.JSX.Element {
  return <NavigationCards {...props} />;
}
